/* @flow */
import ComposableTableHeader from './ComposableTableHeader';
import type { ComposableTableHeaderSortProps } from './ComposableTableHeader';

export default ComposableTableHeader;
export type { ComposableTableHeaderSortProps };
